
export class STATE {
  static ON:boolean = true;
  static YES:boolean = true;
  static OFF:boolean = false;
  static NO:boolean = false;
}

export class A {
  static TRANSPARENT_ITEM:string = 'transitem';
  static TRANSPARENT_TERRAIN:string = 'transterrain';
  static POINTCLOUD:string = 'pointcloud';
  static TERRAIN:string = 'terrain';
}

export class IS {
  static TRANSPARENT:string = 'transparent';
  static COLORIZED:string = 'colorized';
}

export class TURN {
  static ON:boolean = true;
  static OFF:boolean = false;
}
